import { ChangeDetectorRef, Component, OnInit, ViewChild, AfterViewChecked, AfterViewInit, HostListener } from '@angular/core';
import { QuestionnaireService } from '../services/questionnaire.service';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, FormArray, FormControl } from '@angular/forms';
import { ValidateId } from "../id-validator";
import { LeadService } from "../services/lead.service";
import { ValidateDate } from '../date-validator';
import { BorrowersArrayComponent } from '../borrowers-array/borrowers-array.component';
import { Draft } from '../services/draft.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsOfUseComponent } from '../terms-of-use/terms-of-use.component';
import { UtilService } from '../services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { MessagesError } from '../classes/messages-error-type';
import { AddBorrowersState } from '../enums/add-borrowers-state';
import { AnimatedInputComponent } from '../animated-input/animated-input.component';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { SystemTablesService } from '../services/system-tables.service';
import { OtpService } from '../services/otp.service';
import { environment } from '../../environments/environment';
import { AnalyticsService } from '../services/analytics.service'

@Component({
	selector: 'app-user-details',
	templateUrl: './user-details.component.html',
	styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit, AfterViewChecked, AfterViewInit {
	isloading1: Boolean;
	isloading2: Boolean;
	isloading3: Boolean;
	errorMessage: string;
	userDetails: FormGroup;
	prevQID: any;
	whatsAppLink = environment.common.whatsAppLink;
	private route$: Subscription;
	qID: any;
	isAdvisor = this.questionnaireService.getIsAdvisor();
	currentStep;
	visibleQids;
	currentStepName;
	isMobilePhone: boolean;
	isMobilePrefixOnly: boolean = true;
	submitted = false;
	editQuestion;
	minBirthDate = { year: (new Date().getFullYear()) - 100, month: 1, day: 1 }; //from -100 years
	maxBirthDate = { year: (new Date().getFullYear()) - 15, month: 12, day: 31 };  //to 15 years old
	defaultValue = "";
	//maritalStatus: string[] = ["רווק", "נשוי", "גרוש", "אלמן"];
	borrowers;
	isEdit;
	proximity;
	modalRef;
	status;
	statusTable;
	isSubmit = false;
	buttonGoContinueProcess = false;
	areTablesLoading = true;
	tmpValue;
	arrayErrorMsgCheckBorrower = new Map([]);
	qFields = {
		1: [
			{ name: "firstName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "lastName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }
		],
		// ValidateId
		2: [{ name: "idNumber", validators: [Validators.required, ValidateId, Validators.maxLength(9), Validators.minLength(9)] }],
		3: [{ name: "birthDate", validators: [Validators.required, ValidateDate], type: "Date" }],
		4: [{ name: "phoneNumber", validators: [Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")] }],
		4.5: [{ name: 'email', validators: [Validators.required, Validators.pattern("^[\\w-\\.]+@([\\w-]+\.)+[\\w-]{2,4}$")] }],
		5: [{ name: "maritalStatus", validators: [Validators.required], systemTable: "stringTable", numberSystemTable: ["1719"] }],
		6: [{ name: "areThereAdditionalBorrowers", validators: [] }],
		6.1: [{ name: "agreeEmail", validators: [] }],
		7: [{
			name: "borrowersArray", type: "BorrowersArray", systemTable: "arrayTable",
			qNamesSystemTable: [[["borrowerProximity"], ["borrowerProximity"], ["borrowerProximity"], ["borrowerProximity"], ["borrowerProximity"]]],
			numberSystemTable: [[["1708"], ["1708"], ["1708"], ["1708"], ["1708"]]]
		}]
	};

	qArrFields = {
		7: [
			{ name: "borrowerFullName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת]+([\ ]([A-Za-zא-ת])+)+$")] },
			{ name: "borrowerPhoneNumber", validators: [Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")] },
			{ name: "borrowerBirthDate", validators: [Validators.required, ValidateDate], type: "Date" },
			{ name: "borrowerIdNumber", validators: [Validators.required, ValidateId, Validators.maxLength(9), Validators.minLength(9)] },
			{ name: "borrowerProximity", validators: [Validators.required] },
			{ name: "borrowerId", validators: [] },
			{ name: "borrowerEmail", validators: [Validators.required, Validators.pattern("^[\\w-\\.]+@([\\w-]+\.)+[\\w-]{2,4}$")] },
		],
	}

	checkBorrowerSubscription: Subscription;
	isDisplayed: boolean = false;
	allreadySubmittedValues: any;
	errorMessageOnComponent: Array<MessagesError>;
	errorMessageOnComponentBorrower: Array<MessagesError>;
	errorMessageOnComponent6: Array<MessagesError>;
	errorMessageOnComponent7: Array<MessagesError>;
	isDisplayed6: boolean = false;
	isDisplayed7: boolean = false;
	@ViewChild('firstName') firstName: AnimatedInputComponent;
	@ViewChild('lastName') lastName: AnimatedInputComponent;
	@ViewChild('idNumber') idNumber: AnimatedInputComponent;
	@ViewChild('birthDate') birthDate: DatePickerComponent;
	@ViewChild('email') email: AnimatedInputComponent;

	constructor(
		private fb: FormBuilder,
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private draft: Draft,
		private modalService: NgbModal,
		private translate: TranslateService,
		private systemTablesService: SystemTablesService,
		private router: Router,
		private analyticsService: AnalyticsService,
		private otpService: OtpService,
		private _changeDetector: ChangeDetectorRef) { }


	ngOnInit() {
		this.systemTablesService.areSysTablesLoaded$().subscribe(loaded => {
			if (loaded) {
				this.areTablesLoading = false;
				this.loadTables();
				this.errorMessage = "";
				this.questionnaireService.dataChangedEvent.subscribe(() => {
					this.userDetails.reset();
				});
				this.formCreation();
			}
		});
	}

	private formCreation() {
		this.createForm();
		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;
			this.currentStepName = "user-details";


			let quest1 = this.questionnaireService.getQuestion(this.currentStep, "5");
			let quest7 = this.questionnaireService.getQuestion(this.currentStep, "7");
			let quest6 = this.questionnaireService.getQuestion(this.currentStep, "6");
			let respKirva = quest1.answer.fields.find(i => i.answerText === "מצב משפחתי");
			//let step4 = this.questionnaireService.getStepByID("4");
			if (!this.draft.isBuildForm) {
				this.checkIfMerried(respKirva, quest6, quest7);
			}

			if (params.qid === "all") {
				this.isEdit = true;
				//this.visibleQids = "all";
				const visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);

				if (respKirva.answerValue && respKirva && respKirva.answerValue == 'נשוי/ה') {
					this.visibleQids = visibleQids.filter(val => val != "6");
				}
				else {
					this.visibleQids = visibleQids;
				}
				this.clearPreviousQuestionValidators();
				//console.log("++++  ++++  ++++  ++++>>>  UserDetailsComponent",answeredQuestions);
			} else {
				this.isEdit = false;
				this.setValidators();
				const visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				if ((!respKirva.answerValue && respKirva && respKirva != 'נשוי/ה') || (respKirva.answerValue && respKirva.answerValue != 'נשוי/ה')) {
					this.visibleQids = visibleQids.filter(val => val != "7");
				}
				else {
					if (respKirva.answerValue && respKirva && respKirva.answerValue == 'נשוי/ה') {
						this.visibleQids = visibleQids.filter(val => val != "6");
					}
					else {
						this.visibleQids = visibleQids;
					}

				}

				if (this.qID !== '1') {
					this.setFocusFirstComponent(this.qID);
				}
			}
		});
		if (this.draft.autoForm) {
			this.userDetails = this.draft.buildForm(this.currentStep, this.userDetails);
		}
		this.checkBorrowerSubscription = this.draft.checkBorrowerStatus$.subscribe(res => {
			if ((this.qID === '4.5' || this.qID === '7') && (res.type && res.type === 2) && (res.code && res.code.message === '-1')) {
				this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 1 - התחלה", "general_error");
				this.isloading1 = false;
				this.isloading2 = false;
				this.isloading3 = false;
				this.isDisplayed = true;
				this.errorMessageOnComponent = [{ text: this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION') }];
				this.errorMessageOnComponentBorrower = [{ text: this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION') }];
			} else if ((this.qID === '4.5' || this.qID === '7') && (res.type && res.type === 2) && (res.code && res.code.message === '1')) {
				this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 1 - התחלה", "crm נמצא בתהליך מול");
				this.isDisplayed = true;
				if (this.qID === '4.5') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.CUSTOMER_EXIST_IN_SYSTEM')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.CUSTOMER_EXIST_IN_SYSTEM')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}]);
				}
				if (this.qID === '7') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.BORROWER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.BORROWER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}]);
				}
				this.isloading1 = false;
				this.isloading2 = false;
				this.isloading3 = false;
			} else if ((this.qID === '4.5' || this.qID === '7') && (res.type && res.type === 2) && (res.code && res.code.message === '2')) {
				this.isDisplayed = true;
				this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 1 - התחלה", "קיימת בקשת משכנתא");
				if (this.qID === '4.5') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.CUSTOMER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.CUSTOMER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}]);
				}
				if (this.qID === '7') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.BORROWER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.BORROWER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}]);
				}
				this.isloading1 = false;
				this.isloading2 = false;
				this.isloading3 = false;
				this.buttonGoContinueProcess = true;
			} else if ((this.qID === '4.5' || this.qID === '7') && (res.type && res.type === 2) && (res.code && res.code.message === '3')) {
				this.isDisplayed = true;
				this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 1 - התחלה", "פרטים לא נכונים");
				if (this.qID === '4.5') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.DETAILS_FAILD')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.DETAILS_FAILD')
					}]);
				}
				if (this.qID === '7') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.DETAILS_FAILD')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.DETAILS_FAILD')
					}]);
				}
				this.isloading1 = false;
				this.isloading2 = false;
				this.isloading3 = false;
				this.buttonGoContinueProcess = true;
			} else if ((this.qID === '4.5' || this.qID === '7') && (res.type && res.type === 2) && (res.code && res.code.message === '28')) {
				this.isDisplayed = true;
				this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 1 - התחלה", "קיימת בקשת משכנתא");
				if (this.qID === '4.5') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.CUSTOMER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.CUSTOMER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}]);
				}
				if (this.qID === '7') {
					this.errorMessageOnComponent = [{
						text: this.translate.instant('USER_DETAILS.Q4.BORROWER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}];
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{
						text: this.translate.instant('USER_DETAILS.Q4.BORROWER_EXIST_IN_Draft')
							.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
					}]);
				}
				this.isloading1 = false;
				this.isloading2 = false;
				this.isloading3 = false;
				this.buttonGoContinueProcess = true;
			}
			else if (this.qID === '4.5' || this.qID === '7') {
				let q;
				let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;
				q = this.qFields[submitQID];

				let values = q.map(r => {
					return this.allreadySubmittedValues[r.name];
				});

				this.questionnaireService.sendGA(this.currentStep, this.qID, values);
				this.isloading1 = false;
				this.isloading2 = false;
				this.isloading3 = false;
				this.buttonGoContinueProcess = false;
				this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{ text: "" }]);
				this.errorMessageOnComponent = [{ text: "" }];
				this.errorMessageOnComponentBorrower = [{ text: "" }];
				if (this.isSubmit) {
					this.nextClick(submitQID, values);
				}

			}
		},
			() => {
				this.isloading1 = false;
				this.isloading2 = false;
				this.isloading3 = false;
				this.errorMessageOnComponent = [{ text: this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION') }];
				this.errorMessageOnComponentBorrower = [{ text: this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION') }];
			},
		);
	}
	addBorrowerError() {
		this.errorMessageOnComponent7 = [{ text: this.translate.instant('BORROWERS_DETAILS.ERROR.ADD_ERROR') }];
		this.isDisplayed7 = true;
	}
	offLoader() {
		this.isloading1 = false;
		this.isloading2 = false;
		this.isloading3 = false;
		this.isDisplayed = false;
		this.isDisplayed6 = false;
		this.isDisplayed7 = false;
	}

	private loadTables() {
		this.proximity = this.systemTablesService.getTable('1708');
		this.statusTable = this.systemTablesService.getTable('1719', false);
		this.status = this.statusTable.map(t => t.name);
	}

	private setFocusFirstComponent(qID) {
		if (this.qID === '1') {
			this.firstName.inp1.nativeElement.focus();
		} else if (this.qID === '2') {
			this.focusToElement(`input[aria-label="${this.translate.instant('USER_DETAILS.Q2.PH1')}"]`);
		} else if (this.qID === '3') {
			this.focusToElement(`label[data-id="qID3a"`);
		} else if (this.qID === '4') {
			this.focusToElement(`input[aria-label="${this.translate.instant('HELP_DIALOG.PHONE_NUMBER_PC')}"]`);
		} else if (this.qID === '4.5') {
			this.focusToElement(`input[aria-label="${this.translate.instant('USER_DETAILS.Q4-5.LABEL')}"]`);
		} else if (this.qID === '5') {
			this.focusToElement(`div[aria-label="${this.translate.instant('USER_DETAILS.Q5.LABEL')}"]`);
		} else if (this.qID === '6') {
			this.focusToElement(`label[data-id="qID6a"`);
		}

	}

	checkIfMerried(respKirva: any, quest6: any, quest7: any) {
		if (respKirva.answerValue === "נשוי/ה" || (this.qID == '7' && respKirva.answerValue === "נשוי/ה")) {
			quest7.answer['answer-data'][0].fields[4].answerValue = "בן/ בת זוג";
			quest6.selectedAnswer = "YES";
			quest7.answer['answer-data'][0].fields.required = true;
			this.borrowers = this.questionnaireService.getBorrowers();
			this.rebuildFormFor7(respKirva.answerValue, this.qID);
		} else if (respKirva.answerValue !== "נשוי/ה") {
			quest7.answer['answer-data'][0].fields.required = false;
			this.borrowers = this.questionnaireService.getBorrowers();
			this.rebuildFormFor7(respKirva.answerValue);
		}
	}
	rebuildFormFor7(kirva?: any, qID?: any) {
		this.userDetails.setControl('borrowersArray', BorrowersArrayComponent.builBorrowers(this.questionnaireService.getQuestion(this.currentStep, "7").answer['answer-data'], kirva, qID));
	}
	createForm() {
		this.currentStep = this.questionnaireService.getStep("user-details");
		let dateValue;
		if (typeof this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue === 'string') {
			dateValue = this.questionnaireService.customFormat(this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue)
		} else {
			dateValue = this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue
		}
		this.userDetails = this.fb.group({
			firstName: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			lastName: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[1].answerValue,
			idNumber: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			birthDate: dateValue,
			phoneNumber: this.questionnaireService.getQuestion(this.currentStep, "4").answer.fields[0].answerValue,
			maritalStatus: this.questionnaireService.getQuestion(this.currentStep, "5").answer.fields[0].answerValue,
			agreeEmail: this.questionnaireService.getQuestion(this.currentStep, "6").selectedAnswer,
			areThereAdditionalBorrowers: this.questionnaireService.getQuestion(this.currentStep, "6.1").selectedAnswer,
			borrowersArray: BorrowersArrayComponent.builBorrowers(this.questionnaireService.getQuestion(this.currentStep, "7").answer['answer-data']),
			email: this.questionnaireService.getQuestion(this.currentStep, "4.5").answer.fields[0].answerValue
		});
	}

	updateValidators() {
		this.setValidators();
		this.focusNextElement();
	}

	validatePhone(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value && control.value.includes("בחר")) {
				return {
					required: true
				};
			}
			if (this.isMobilePhone && control.value && control.value.length < 10) {//isMobilePhone not working
				return {
					minlength: true
				};
			} else if (!this.isMobilePhone && control.value && control.value.length < 9) {//isMobilePhone not working
				return {
					minlength: true
				};
			}
		};
	}

	setValidators() {
		// if (this.prevQID) {
		this.isDisplayed7 = false;
		this.isDisplayed = false;
		this.clearPreviousQuestionValidators();
		// }
		this.questionnaireService.clearAllQuestionValidators(this.userDetails.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.userDetails.controls, this.qFields, "1", this.qArrFields, false);

		for (let i = 0; i < this.qFields[this.qID].length; i++) {
			let field = this.qFields[this.qID][i];
			this.userDetails.controls[field.name].setValidators(field.validators);
			this.userDetails.controls[field.name].updateValueAndValidity();
		}
		this.submitted = false;
	}

	clearPreviousQuestionValidators() {
		console.log("clearPreviousQuestionValidators()");

		let keys = Object.keys(this.qFields);

		for (let i = 0; i < keys.length; i++) {

			for (let j = 0; j < this.qFields[keys[i]].length; j++) {
				this.userDetails.controls[this.qFields[keys[i]][j].name].setValidators(null);
				this.userDetails.controls[this.qFields[keys[i]][j].name].updateValueAndValidity();
			}
		}
	}
	goContinueProcess() {
		this.router.navigate(["login"]);
		this.questionnaireService.setIsAdvisor(false);
		this.draft.ConsultantId = "";
		this.draft.ConsultFirmId = "";
	}

	nextClick(qID, answers) {
		if (answers) {
			if (qID === "5" && answers[0] != 'נשוי/ה') {
				this.questionnaireService.clearAllQuestionValidators(this.userDetails.controls, this.qFields, this.qArrFields);
			}
			if (((qID === "6" && answers[0] == 'NO') || qID === "7")) {
				this.openTermsOfUse(qID, answers);
			}
			else {
				this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
				this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
			}
		}
		this.isSubmit = false;
	}
	checkBorrowers(): AddBorrowersState {
		const borrowerIdNumber: string = (this.userDetails.get('borrowersArray') as FormArray).controls[(this.userDetails.get('borrowersArray') as FormArray).length - 1].value.borrowerIdNumber;
		if (borrowerIdNumber === this.userDetails.get('idNumber').value) {
			return AddBorrowersState.EqualToCustomer;
		} else {
			for (let i = 0; i < (this.userDetails.get('borrowersArray') as FormArray).controls.length - 1; i++) {
				if ((this.userDetails.get('borrowersArray') as FormArray).controls[i].value.borrowerIdNumber == (this.userDetails.get('borrowersArray') as FormArray).controls[(this.userDetails.get('borrowersArray') as FormArray).length - 1].value.borrowerIdNumber) {
					return AddBorrowersState.ExistInBorrowers;
				}
			}
			return AddBorrowersState.Valid
		}
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent): any {
		if (event.key === 'Enter') {
			if ((event.target as HTMLElement).dataset.fieldname === 'areThereAdditionalBorrowers') {
				this.userDetails.controls[(event.target as HTMLElement).dataset.fieldname].setValue((event.target as HTMLElement).dataset.fieldvalue);
				this.onSubmit(this.userDetails);
			}

		}

	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		this.submitted = true;
		this.isSubmit = true;
		if (!valid) {
			this.questionnaireService.submitForm(true);
			this.isSubmit = false;
		}
		else {
			this.questionnaireService.submitForm(false);
		}
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit():  value=", value, "valid=", valid);
		if (this.qID == '7') {
			const addBorrowersState: AddBorrowersState = this.checkBorrowers();
			this.draft.indexCheckBorrower = value.borrowersArray.length - 1;
			if (this.draft.listLoansArrayforCreateOpp.length > 1 && this.draft.listCreateCustomerBorrowersArray.length > 1) {
				this.draft.listLoansArrayforCreateOpp = this.draft.listLoansArrayforCreateOpp.slice(0, 1)
				this.draft.listCreateCustomerBorrowersArray = this.draft.listCreateCustomerBorrowersArray.slice(0, 1)
			}
			if (valid && value.borrowersArray.length > 0) {
				if (addBorrowersState === AddBorrowersState.Valid) {
					this.submitActions(value);
				} else {
					this.isDisplayed = true;
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{ text: this.translate.instant('USER_DETAILS.Q7.ID_NUM_IS_EQUAL_TO_ID_PREVIOUS') }])

				}
			}
		} else {

			if (valid) {
				this.submitActions(value);
			}
		}
	}
	failedAddBorrowersCause(state: AddBorrowersState) {
		if (this.qID === '7') {
			if (state == AddBorrowersState.EqualToCustomer) {
				this.isDisplayed = true;
				this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{ text: this.translate.instant('USER_DETAILS.Q7.ID_NUM_IS_EQUAL_TO_ID_PREVIOUS') }])

			} else {
				if (state == AddBorrowersState.ExistInBorrowers) {
					this.isDisplayed = true;
					this.arrayErrorMsgCheckBorrower.set(this.draft.indexCheckBorrower, [{ text: this.translate.instant('USER_DETAILS.Q7.ID_NUM_IS_EQUAL_TO_ID_PREVIOUS') }])

				} else {

				}
			}
		}
	}
	submitActions(value: any) {
		let q;
		let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;
		q = this.qFields[submitQID];
		let values = q.map(r => {
			return value[r.name];
		});
		if (submitQID === '4.5') {
			this.isloading1 = true;
		}
		if (submitQID === '4' && this.otpService.isNewForm) {
			this.otpService.phoneOk = true;
		}
		if ((!(submitQID === '4' && this.otpService.getCode == false)) || this.questionnaireService.getIsAdvisor()) {

			if (value.maritalStatus === 'נשוי/ה' && submitQID === "7") {
				if (value.borrowersArray[0]) {
					if (!(value.borrowersArray[0].borrowerProximity)) {
						value.borrowersArray[0].borrowerProximity = "בן/ בת זוג";
					}
				}
			}
			let valueTmp = JSON.parse(JSON.stringify(value))
			this.tmpValue = valueTmp;
			if (submitQID === '7') {
				this.isloading3 = true;
				valueTmp.borrowersArray.forEach((element) => {
					let borrowerProximityCode = this.proximity.find(v => v.name === element.borrowerProximity).code;
					element.borrowerProximity = borrowerProximityCode;
				});
				this.draft.buildArrDraft(submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit);
			}
			else if (submitQID === '5') {
				let maritalStatus = this.statusTable.find(v => v.name === value["maritalStatus"]).code;
				valueTmp["maritalStatus"] = maritalStatus;
				this.draft.buildArrDraft(submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit);
			}
			else {
				this.draft.buildArrDraft(submitQID, this.qFields, value, this.currentStep, this.isEdit);
			}
			if (value.maritalStatus === 'נשוי/ה' && submitQID === "5") {
				if (value.areThereAdditionalBorrowers === "") {
					value.areThereAdditionalBorrowers = "YES";
				}
				this.draft.buildArrDraft("6", this.qFields, value, this.currentStep, false);
			}
			if (submitQID !== '4.5' && submitQID !== '7') {
				this.questionnaireService.sendGA(this.currentStep, this.qID, values);
				this.nextClick(submitQID, values);
			} else {
				this.allreadySubmittedValues = value;
			}
		}
	}


	editQuestionChange(qid) {
		this.qID = qid;
		this.setValidators();
	}

	offError() {
		this.isDisplayed7 = false;
		this.isDisplayed = false;
	}

	openTermsOfUse(qID, answers) {
		this.modalRef = this.modalService.open(TermsOfUseComponent, { size: 'lg' });
		this.modalRef.componentInstance.agreeEmail = new FormControl(true);
		this.modalRef.result.then((result) => {
			if (result) {
				this.userDetails.controls.agreeEmail.patchValue(result.agreeEmail ? 'YES' : 'NO');
				this.tmpValue.agreeEmail = this.userDetails.controls.agreeEmail.value;
				let valueTmp = JSON.parse(JSON.stringify(this.tmpValue));
				// valueTmp.borrowersArray.forEach((element) => {
				// 	if(this.proximity.find(v => v.name === element.borrowerProximity)?.code){
				// 		let LoanPurposeDetails = this.proximity.find(v => v.name === element.borrowerProximity).code;
				// 		element.borrowerProximity = LoanPurposeDetails;
				// 	}
				// });
				this.draft.buildArrDraft('6.1', this.qFields, valueTmp, this.currentStep, this.isEdit);
			}
			if (qID === '6')
				this.isloading2 = true;
			if (qID === '7')
				this.isloading3 = true;
			this.draft.setBorrowers$().subscribe(
				r => {
					this.questionnaireService.setAsmachta(r['oppid']);
					this.isloading2 = false;
					this.isloading3 = false;
					// console.log('setBorrowers...', r);
					this.navigatetoStepTwo(this.currentStep, qID, answers);
					this.errorMessageOnComponentBorrower = [{ text: "" }];
					this.isDisplayed6 = false;
					this.isDisplayed7 = false;
				},
				err => {
					this.isloading2 = false;
					this.isloading3 = false;
					if ((err.type && err.type === 2) && (err.code && err.code.message === '-1')) {
						this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 1 - התחלה", "general_error");
					}
					console.log('setBorrowers error...', err);
					if (qID === '6') {
						this.errorMessageOnComponent6 = [{ text: this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION') }];
						this.isDisplayed6 = true;
					}
					if (qID === '7') {
						this.errorMessageOnComponent7 = [{ text: this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION') }];
						this.isDisplayed7 = true;
					}
					// this.navigatetoStepTwo(this.currentStep, qID, answers);
				}
			);
			// this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			// this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		});
	}

	private navigatetoStepTwo(currentStep, qID, answers) {
		this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
		this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
	}

	toggleYes() {
		this.userDetails.controls['areThereAdditionalBorrowers'].setValue('YES');
		this.onSubmit(this.userDetails);
	}

	toggleNo() {
		this.userDetails.controls['areThereAdditionalBorrowers'].setValue('NO');
		this.onSubmit(this.userDetails);
	}

	ngAfterViewInit() {
		this.setFocusFirstComponent('1');
		// console.log('ngAfterViewInit...')
	}

	ngAfterViewChecked(): void {
		if (!this._changeDetector['destroyed']) {
			this._changeDetector.detectChanges();
		}
	}

	dpListSelectChange(item) {
		if (item !== 'בחר') {
			this.focusNextElement();
		}
	}

	onCompleteFill(evt) {
		this.focusNextElement();
	}

	onDateUpdate(evt) {
		this.focusToElement('button[data-qid="3"]');
		// console.log('onDateUpdate');
	}

	focusNextElement() {
		const arrayElement = Array.from(document.querySelectorAll('[tabindex]'));
		const focussableIndex = arrayElement.indexOf(document.activeElement);
		if (focussableIndex > -1) {
			const nextElement = arrayElement[focussableIndex + 1] || arrayElement[0];
			(nextElement as HTMLElement).focus();
		}
	}

	focusToElement(selector: string) {
		const selectedElement = Array.from(document.querySelectorAll(selector));

		if (selectedElement && selectedElement.length > 0) {
			const nowActiveElement = document.activeElement;
			(nowActiveElement as HTMLElement).blur();
			setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
			// console.log ('active element', document.activeElement)
			// console.log ('selected element', selectedElement[0])
		}
	}

	continueWithPhoneNum(qID, values) {
		this.questionnaireService.sendGA(this.currentStep, qID, values);
	}

}



// WEBPACK FOOTER //
// ./src/app/user-details/user-details.component.ts